var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 24.08,
    fill: "#4e8ef7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4e8ef7",
    d: "M113.14,23.14a8.27,8.27,0,0,0-13.7-6.25,59,59,0,1,0,11.67,11.67A8.24,8.24,0,0,0,113.14,23.14ZM64,121A57,57,0,1,1,98.1,18.36a8.27,8.27,0,0,0,11.53,11.53A57,57,0,0,1,64,121Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.648b025c7714531b1c0a4b7ff6faff70.svg";
export { ForwardRef as ReactComponent };